import React from 'react';

interface IProps {
  question: string;
  answer: string;
}

export const Question = (props: IProps) => {
  return (
    <details className="mb-4">
      <summary className="cursor-pointer font-semibold">
        {props.question}
      </summary>
      <p className="mt-2">{props.answer}</p>
    </details>
  );
};
